import React, { useState, useEffect } from 'react';
import {Button, Container, Grid, Slider} from "@material-ui/core";
import Toolbar from "@material-ui/core/Toolbar";
import { Link } from "react-router-dom";
//import '../assets/styles/PreConEmail.css'; // Importing styles
import "../assets/styles/NewSmartReport.css"
// import "bootstrap/dist/css/bootstrap.min.css";
// // Bootstrap Bundle JS
// import "bootstrap/dist/js/bootstrap.bundle.min";
import {
  PieChart,
  Pie,
  Cell,
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer
} from 'recharts';
import CheckIcon from '@material-ui/icons/Check';
import AddCircleOutlineIcon from '@material-ui/icons/AddCircleOutline';
import RemoveCircleOutlineIcon from '@material-ui/icons/RemoveCircleOutline';
import Breadcrumb from "./BreadcrumbsComponent";


const ReportPreview = () => {
  const [images, setImages] = useState([]);

  useEffect(() => {
    const loadImages = () => [
      "../src/assets/images/area_analysis_1.png",
      "../src/assets/images/area_analysis_2.png",
      "../src/assets/images/area_analysis_3.png",
        "../src/assets/images/area_analysis_4.png",
    ];

    setImages(loadImages());
  }, []);

  const areaDescription = "This is a thriving area with a mix of residential and commercial properties. It's a highly walkable area with excellent access to amenities and public transportation. The area has seen consistent growth over the past few years and is anticipated to continue this trend in the future."

const genderData = [{ name: 'Males', value: 40 }, { name: 'Females', value: 60 }];
const ageData = [{ name: 'Age 20-29', value: 20 }, { name: 'Age 30-39', value: 30 }, { name: 'Age 40-49', value: 25 }, { name: 'Age 50+', value: 25 }];
const maritalStatusData = [{ name: 'Married Individuals', value: 60 }, { name: 'Single Individuals', value: 30 }, { name: 'Divorced Individuals', value: 10 }];
const incomeData = [{ name: 'Income <$50K', value: 20 }, { name: 'Income $50-100K', value: 30 }, { name: 'Income $100-150K', value: 25 }, { name: 'Income >$150K', value: 25 }];

  const COLORS = ['#0088FE', '#00C49F', '#FFBB28', '#FF8042'];
  const homes = [
    {
      image: "../src/assets/images/Home_Image_1.jpeg",
      location: "Location 1",
      bedrooms: 3,
      bathrooms: 2,
      squareFootage: 1500,
      lotSize: "0.5 acres",
      highlights: "Highlight 1, Highlight 2",
      priceEstimate: "$500,000",
      priceAdjustments: [{ adjustment: "+$10,000", reason: "Location" }, { adjustment: "-$5,000", reason: "Age" }, { adjustment: "+$5,000", reason: "Size" }],
      compatibility: { rating: 8, comment: "Highly Compatible" }
    },
    {
      image: "../src/assets/images/Home_Image_2.jpeg",
      location: "Location 2",
      bedrooms: 4,
      bathrooms: 3,
      squareFootage: 1800,
      lotSize: "0.6 acres",
      highlights: "Highlight 1, Highlight 2",
      priceEstimate: "$700,000",
      priceAdjustments: [{ adjustment: "+$20,000", reason: "Design" }, { adjustment: "-$5,000", reason: "Age" }, { adjustment: "+$15,000", reason: "Luxury" }],
      compatibility: { rating: 7, comment: "Moderately Compatible" }
    },
    {
      image: "../src/assets/images/Home_Image_3.jpeg",
      location: "Location 3",
      bedrooms: 2,
      bathrooms: 2,
      squareFootage: 1200,
      lotSize: "0.4 acres",
      highlights: "Highlight 1, Highlight 2",
      priceEstimate: "$400,000",
      priceAdjustments: [{ adjustment: "+$8,000", reason: "Coziness" }, { adjustment: "-$2,000", reason: "Size" }, { adjustment: "+$5,000", reason: "Tranquility" }],
      compatibility: { rating: 9, comment: "Very Compatible" }
    }
  ]


  return (
      <Container>
        <Grid container spacing={3}>
      <Breadcrumb />
        </Grid>

          <div className="core-element reduced-margin">
      <div className="give_margin give_top_padding font-link" style={{marginBottom: "-10px"}}>
        <Toolbar>
          <Button variant="contained" color="secondary" component={Link} to="/smart-reports/new-smart-report">
            Edit
          </Button>
          <div style={{ flex: 1 }}></div>
          <Button variant="contained" color="primary">
            Auto Generate
          </Button>
          <Button variant="contained" color="secondary">
            Publish
          </Button>
        </Toolbar>
      </div>

      <div className="docPage">
        <div className="give_margin give_top_padding font-link">
            <h1>Area Analysis and Demographics</h1>
            <hr style={{marginTop: "10px"}}/>
          <p style={{marginTop: "10px", fontSize: "18.5px", lineHeight: "150%"}}>
Located at 369 Bay Street, this property stands as a reflection of its surrounding real estate landscape, a microcosm of the market dynamics at play. Delving into a Comparative Market Analysis (CMA) provides not only a valuation anchor for this property but also offers insights into the local real estate trends, neighborhood attributes, and how similar properties are faring. Whether you're a potential buyer, seller, or a curious observer, this CMA aims to furnish you with a nuanced, data-driven understanding of 369 Bay Street's position in the broader market. Join us as we navigate through its intricacies, ensuring that you're well-informed for any property decisions ahead.</p>
        </div>
        <div className="give_margin give_top_padding font-link" style={{marginTop: "-20px"}}>
                    <h2>Property Images</h2>
                    <hr style={{marginTop: "10px"}}/>
        </div>

        <div style={{ display: "flex", justifyContent: "center", flexWrap: "wrap", marginLeft: "25px", marginRight: "25px" }}>
          {images.map((url, index) => (
            <div key={index} style={{ flex: `1 0 calc(100% / 2 - 10px)`, margin: "5px" }}>
              <img src={url} alt={`Property ${index + 1}`} style={{ width: "100%", height: "auto", objectFit: "cover", borderRadius: "10px" }} />
            </div>
          ))}
        </div>

        <div className="give_margin give_top_padding font-link">
            <h2>Area Analysis</h2>
            <hr style={{marginTop: "10px"}}/>
            <p style={{marginTop: "10px", fontSize: "18.5px", lineHeight: "150%"}}>{areaDescription}</p>
        </div>
        <div className="area-border">
          <div style={{ display: 'flex', justifyContent: 'space-around', marginTop: '10px', marginBottom: '10px' }} className="give_margin give_top_padding font-link">
            <div style={{marginLeft: "10px"}}></div>
            <ResponsiveContainer width="45%" height={250}>
              <PieChart>
                <Pie dataKey="value" data={genderData} cx="50%" cy="50%" outerRadius={80}>
                  {genderData.map((entry, index) => <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} />)}
                </Pie>
                <Tooltip />
                <Legend />
              </PieChart>
            </ResponsiveContainer>
              <ResponsiveContainer width="45%" height={250} >
                <BarChart data={ageData}>
                  <CartesianGrid strokeDasharray="3 3" />
                  <XAxis dataKey="name" />
                  <YAxis />
                  <Tooltip />
                  <Legend />
                  <Bar dataKey="value" fill="#8884d8" name="Age Groups" />
                </BarChart>
              </ResponsiveContainer>
            <div style={{marginRight: "25px"}}></div>
          </div>
          <div style={{ display: 'flex', justifyContent: 'space-around', marginTop: '0px' }}>
            <div style={{marginLeft: "10px"}}></div>
            <ResponsiveContainer width="45%" height={300}>
              <PieChart>
                <Pie dataKey="value" data={maritalStatusData} cx="50%" cy="50%" outerRadius={80}>
                  {maritalStatusData.map((entry, index) => <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} />)}
                </Pie>
                <Tooltip />
                <Legend />
              </PieChart>
            </ResponsiveContainer>
            <ResponsiveContainer width="45%" height={300}>
              <BarChart data={incomeData}>
                <CartesianGrid strokeDasharray="3 3" />
                <XAxis dataKey="name" />
                <YAxis />
                <Tooltip />
                <Legend />
                <Bar dataKey="value" fill="#82ca9d" name="Income Groups" />
              </BarChart>
            </ResponsiveContainer>
            <div style={{marginRight: "25px"}}></div>
          </div>
        </div>

        <div className="give_margin give_top_padding font-link">
            <h1>Comparables Analysis</h1>
            <hr style={{marginTop: "10px"}}/>
        </div>


      <div style={{ display: "flex", justifyContent: "space-between", flexWrap: "wrap", marginLeft: "25px", marginRight: "25px" }}>
        {homes.map((home, index) => (
          <div key={index} style={{ flex: "1", margin: "10px", padding: "10px", border: "1.5px solid #ccc", borderRadius: "5px" }}>
            <img
            src={home.image}
            alt={`Home ${index + 1}`}
            style={{ width: "100%", height: "200px", objectFit: "cover", borderRadius: "5px" }} />
            <div style={{marginBottom: "10px"}}></div>
            <h2>Home {index + 1}</h2>
            <hr style={{margin:"10px"}} />
            <div style={{marginBottom: "10px"}}></div>
            <h3>Home Info</h3>
            <div style={{marginBottom: "10px"}}></div>
            <p>Location: {home.location}</p>
            <div style={{marginBottom: "3px"}}></div>
            <p>Bedrooms: {home.bedrooms}</p>
            <div style={{marginBottom: "3px"}}></div>
            <p>Bathrooms: {home.bathrooms}</p>
            <div style={{marginBottom: "3px"}}></div>
            <p>Square Footage: {home.squareFootage}</p>
            <div style={{marginBottom: "3px"}}></div>
            <p>Lot Size: {home.lotSize}</p>
            <div style={{marginBottom: "3px"}}></div>
            <p>Highlights: {home.highlights}</p>
            <div style={{marginBottom: "10px"}}></div>
            <h3>Smart CMA Price Estimate</h3>
            <div style={{marginBottom: "3px"}}></div>
            <p>{home.priceEstimate}</p>
            <div style={{marginBottom: "10px"}}></div>
            <h3>Suggested Price Adjustments</h3>
            {home.priceAdjustments.map((item, i) => (
              <p key={i}>{item.adjustment.startsWith('-') ? <RemoveCircleOutlineIcon /> : <AddCircleOutlineIcon />} {item.reason}</p>
            ))}
          </div>
        ))}
      </div>

      <div className="give_margin give_top_padding font-link">
          <h1>Compatibility Analysis</h1>
          <hr style={{marginTop: "10px"}}/>
      </div>
      <div style={{ display: "flex", justifyContent: "space-between", flexWrap: "wrap", marginTop: "10px", marginLeft: "25px", marginRight: "25px"}}>
        {homes.map((home, index) => (
          <div key={index} style={{ flex: "1", margin: "10px", padding: "10px", border: "1px solid #ccc", borderRadius: "5px" }}>
            <h2>Home {index + 1}</h2>
            <h3>Compatibility</h3>
            <Slider
              defaultValue={home.compatibility.rating}
              step={1}
              marks
              min={1}
              max={10}
              color={"secondary"}
              valueLabelDisplay="auto"
              disabled
            />
            <p>Comment: {home.compatibility.comment}</p>
          </div>
        ))}

      </div>
      <div className="give_margin give_top_padding font-link">
        <h1>Property Remarks</h1>
        <hr style={{marginTop: "10px"}}/>
        <p style={{marginTop: "10px", fontSize: "18.5px", lineHeight: "150%"}}>In our comprehensive comparative market analysis, the area under review presents a vibrant mix of residential and commercial real estate, noted for its walkability, proximate amenities, and stellar public transportation access. Historically, this area has experienced steady growth—a trend expected to persist. Demographics indicate a balanced spread across various age groups, with a slight skew towards the higher income brackets. Our analysis of selected properties showcased variance in attributes: Property 1 is a 3-bedroom, 2-bathroom residence priced at $500,000, Property 2 offers 4 bedrooms and 3 bathrooms at a $700,000 estimate, while Property 3, the coziest of the bunch, is a 2-bedroom, 2-bathroom home estimated at $400,000. These properties were also assessed for compatibility to the area, with Property 3 standing out as the most harmonious fit. This report serves as an invaluable tool for potential investors or homeowners seeking insights into the market's current state and trajectory.</p>
      </div>

      <div style={{marginTop: '10px'}}>
        <p style={{opacity: 0}}>a</p>
      </div>
      </div>



    </div>

      </Container>
  );
};

export default ReportPreview;
